export * from './dashboard/dashboard.component';



// WEBPACK FOOTER //
// ./src/app/shared/index.ts